module.exports = __webpack_public_path__ + "img/level_five.1f6300b3.png";